import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "@quintara/site-kit/styles/site.css";
// light.css loads AFTER site.css and swaps tokens/surfaces — order matters.
import "@quintara/site-kit/styles/light.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
